var _style, _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGround(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 255.1 255.1",
    style: {
      enableBackground: "new 0 0 255.1 255.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E87236;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 127.6,
    cy: 127.6,
    r: 121.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83.051,173.856c-0.043,0-0.073-0.042-0.059-0.083L123.28,70.938c0.009-0.025,0.032-0.041,0.059-0.041h51.007 c0.026,0,0.05,0.017,0.059,0.042l39.689,102.835c0.014,0.04-0.016,0.082-0.059,0.082H83.051L83.051,173.856z M35.359,174.302 c-0.043,0-0.073-0.043-0.058-0.084l31-80.093c0.009-0.024,0.032-0.04,0.058-0.04h26.067c0.043,0,0.073,0.043,0.058,0.083 l-30.009,80.093c-0.009,0.024-0.032,0.041-0.058,0.041H35.359z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGround);
export default __webpack_public_path__ + "static/media/ground.c88b21d0901c43780915d5c9971eaf78.svg";
export { ForwardRef as ReactComponent };